<template>
    <div class="Home">
        <div class="container-fluid">
            <div class="row">
                <div class="col center-text">
                    <h1>{{ WelcomeLabel }}</h1>
                </div>
            </div>
            <div class="row" style="margin-top:30px;">
                <div class="col-12">
                    <h3 class="underline center-text">Check Out These Video Tutorials!</h3>
                </div>
            </div>
            <div class="row" v-for="Group in HelpVideos">
                <div class="col-12" style="margin-top:20px;">
                    <h4>{{ Group.GroupName }}</h4>
                </div>
                <div class="col-lg-4" v-for="Topic in Group.Topics">
                    <b-card :title="Topic.Name" align="center" class="fill-row">
                        <video preload="none" width="100%" height="300" controls
                            source :src="SecuredAssetURL(Topic.URL)" type="video/mp4">
                            Your browser does not support videos
                        </video>
                    </b-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faPhoneVolume } from '@fortawesome/free-solid-svg-icons';
    library.add(faPhoneVolume);
    import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
    library.add(faEnvelope);
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);

    export default {
        created() {
 
        },
        props: [],
        data: function () {
            return {
                HelpVideos: [
                    {
                        GroupName: "New",
                        Topics: [
                            {
                                Name: "Linking Volunteer Families to Churches",
                                URL: "StrongFamilies_LinkingChurches_10"
                            }
                        ]
                    },
                    {
                        GroupName: "Other Topics",
                        Topics: [
                            {
                                Name: "Adding Hosting Inquiries (AKA Helpline Calls)",
                                URL: "StrongFamilies_AddingHostingInquiries_10"
                            },
                            {
                                Name: "Managing Referrals",
                                URL: "StrongFamilies_ManagingReferrals_10"
                            },
                            {
                                Name: "Family Notes",
                                URL: "StrongFamilies_ManagingFamilyNotes_10"
                            },
                            {
                                Name: "Family Documents",
                                URL: "StrongFamilies_ManagingFamilyDocuments_10"
                            },
                            {
                                Name: "Sending Text Messages",
                                URL: "StrongFamilies_DispatchingTextMessages_10"
                            }
                        ]
                    }
                ]
            };
        },
        methods: {
            formatDate(value, fmt = 'MM/DD/YY') {
                return (value == null)
                    ? ''
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            OnClientClicked(rowData) {
                console.log("FROM HOME");
                console.log(rowData);
            },
            SecuredAssetURL(fileName) {
                return this.$baseURL + "/API/SecuredAssets/GetMp4Asset?AssetName=" + fileName;
            }
        },
        components: {

        },
        computed: {
            WelcomeLabel: function () {
                let name = this.$store.state.User.PrivateProfile.FirstName;
                let hour = moment().hours();
                let timeOfDay = "Hello"
                if (hour < 3) {
                    timeOfDay = "Good Evening";
                } else if (hour < 12) {
                    timeOfDay = "Good Morning";
                } else if (hour < 18) {
                    timeOfDay = "Good Afternoon";
                } else {
                    timeOfDay = "Good Evening";
                }
                return timeOfDay + " " + name + "!";
            }
        },
        mounted() {
            
        }
    }
</script>

<style scoped>
</style>